import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import Head from 'next/head'
import { HeaderError } from '../../organisms/header'
import Main from '../main'
import isEmpty from 'lodash/isEmpty'

const ErrorLayout = ({ children, layout: layoutProps }) => {
	const config = useConfig()
	const layoutConfig = config?.layout?.default

	const layout = { ...(layoutConfig ?? {}), ...layoutProps }

	// if config is undefined, we are in a server-side error
	// and we can't render the header because we don't have the configs
	const canRenderHeader = !isEmpty(config)

	return (
		<>
			<Head>
				<meta name="robots" content="noindex,nofollow" />
			</Head>
			<Main beforeContent={canRenderHeader ? <HeaderError /> : null} layout={layout}>
				{children}
			</Main>
		</>
	)
}

export default ErrorLayout
